export const GET_AUTO_QUOTES_START = 'GET_AUTO_QUOTES_START';
export const GET_AUTO_QUOTES_SUCCESS = 'GET_AUTO_QUOTES_SUCCESS';
export const GET_AUTO_QUOTES_FAILED = 'GET_AUTO_QUOTES_FAILED';

export const GET_AUTO_QUOTES_CUSTOMER_START = 'GET_AUTO_QUOTES_CUSTOMER_START';
export const GET_AUTO_QUOTES_CUSTOMER_SUCCESS = 'GET_AUTO_QUOTES_CUSTOMER_SUCCESS';
export const GET_AUTO_QUOTES_CUSTOMER_FAILED = 'GET_AUTO_QUOTES_CUSTOMER_FAILED';

export const DOWNLOAD_AUTO_QUOTES_CUSTOMERS_START = 'DOWNLOAD_AUTO_QUOTES_CUSTOMERS_START';
export const DOWNLOAD_AUTO_QUOTES_CUSTOMERS_SUCCESS = 'DOWNLOAD_AUTO_QUOTES_CUSTOMERS_SUCCESS';
export const DOWNLOAD_AUTO_QUOTES_CUSTOMERS_FAILED = 'DOWNLOAD_AUTO_QUOTES_CUSTOMERS_FAILED';

export const CREATE_AUTO_QUOTE_START = 'CREATE_AUTO_QUOTE_START';
export const CREATE_AUTO_QUOTE_SUCCESS = 'CREATE_AUTO_QUOTE_SUCCESS';
export const CREATE_AUTO_QUOTE_FAILED = 'CREATE_AUTO_QUOTE_FAILED';

export const GET_AUTO_QUOTES_SCHEDULES_START = 'GET_AUTO_QUOTES_SCHEDULES_START';
export const GET_AUTO_QUOTES_SCHEDULES_SUCCESS = 'GET_AUTO_QUOTES_SCHEDULES_SUCCESS';
export const GET_AUTO_QUOTES_SCHEDULES_FAILED = 'GET_AUTO_QUOTES_SCHEDULES_FAILED';

export const EDIT_AUTO_QUOTE_SCHEDULE_START = 'EDIT_AUTO_QUOTE_SCHEDULE_START';
export const EDIT_AUTO_QUOTE_SCHEDULE_SUCCESS = 'EDIT_AUTO_QUOTE_SCHEDULE_SUCCESS';
export const EDIT_AUTO_QUOTE_SCHEDULE_FAILED = 'EDIT_AUTO_QUOTE_SCHEDULE_FAILED';

export const DELETE_AUTO_QUOTE_SCHEDULE_START = 'DELETE_AUTO_QUOTE_SCHEDULE_START';
export const DELETE_AUTO_QUOTE_SCHEDULE_SUCCESS = 'DELETE_AUTO_QUOTE_SCHEDULE_SUCCESS';
export const DELETE_AUTO_QUOTE_SCHEDULE_FAILED = 'DELETE_AUTO_QUOTE_SCHEDULE_FAILED';

export const SET_SELECTED_AUTO_QUOTE = 'SET_SELECTED_AUTO_QUOTE';
export const SET_AUTO_QUOTE_ITEMS = 'SET_AUTO_QUOTE_ITEMS';

export const getAutoQuotesStart = () => ({
  type: GET_AUTO_QUOTES_START
});

export const getAutoQuotesSuccess = (data) => ({
  type: GET_AUTO_QUOTES_SUCCESS,
  data
});

export const getAutoQuotesFailed = (error) => ({
  type: GET_AUTO_QUOTES_FAILED,
  error
});

export const getAutoQuotesCustomersStart = () => ({
  type: GET_AUTO_QUOTES_CUSTOMER_START,
});

export const getAutoQuotesCustomersSuccess = (data) => ({
  type: GET_AUTO_QUOTES_CUSTOMER_SUCCESS,
  data,
});

export const getAutoQuotesCustomersFailed = (error) => ({
  type: GET_AUTO_QUOTES_CUSTOMER_FAILED,
  payload: error,
});

export const downloadAutoQuotesCustomersStart = () => ({
  type: DOWNLOAD_AUTO_QUOTES_CUSTOMERS_START,
});

export const downloadAutoQuotesCustomersSuccess = (data) => ({
  type: DOWNLOAD_AUTO_QUOTES_CUSTOMERS_SUCCESS,
  data,
});

export const downloadAutoQuotesCustomersFailed = (error) => ({
  type: DOWNLOAD_AUTO_QUOTES_CUSTOMERS_FAILED,
  payload: error,
});

export const createAutoQuoteStart = () => ({
  type: CREATE_AUTO_QUOTE_START
});

export const createAutoQuoteSuccess = (data) => ({
  type: CREATE_AUTO_QUOTE_SUCCESS,
  data,
});

export const createAutoQuoteFailed = (error) => ({
  type: CREATE_AUTO_QUOTE_FAILED,
  payload: error,
});

export const getAutoQuotesSchedulesStart = () => ({
  type: GET_AUTO_QUOTES_SCHEDULES_START
});

export const getAutoQuotesSchedulesSuccess = (data) => ({
  type: GET_AUTO_QUOTES_SCHEDULES_SUCCESS,
  data,
});

export const getAutoQuotesSchedulesFailed = (error) => ({
  type: GET_AUTO_QUOTES_SCHEDULES_FAILED,
  payload: error,
});

export const editAutoQuoteScheduleStart = () => ({
  type: EDIT_AUTO_QUOTE_SCHEDULE_START
});

export const editAutoQuoteScheduleSuccess = (data) => ({
  type: EDIT_AUTO_QUOTE_SCHEDULE_SUCCESS,
  data,
});

export const editAutoQuoteScheduleFailed = (error) => ({
  type: EDIT_AUTO_QUOTE_SCHEDULE_FAILED,
  payload: error,
});

export const deleteAutoQuoteScheduleStart = () => ({
  type: DELETE_AUTO_QUOTE_SCHEDULE_START
});

export const deleteAutoQuoteScheduleSuccess = (data, id) => ({
  type: DELETE_AUTO_QUOTE_SCHEDULE_SUCCESS,
  data,
  id
});

export const deleteAutoQuoteScheduleFailed = (error) => ({
  type: DELETE_AUTO_QUOTE_SCHEDULE_FAILED,
  payload: error,
});

export const setSelectedAutoQuote = (data) => ({
  type: SET_SELECTED_AUTO_QUOTE,
  data
});

export const setAutoQuoteItems = (items) => ({
  type: SET_AUTO_QUOTE_ITEMS,
  items
});
